var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_57_2660",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_57_2660",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEFElEQVRoge1ZW0hVQRTdZmmiFeZHTxLKr4KiIvqIyKCP3gW97AkJmlqZQiKakIg9qDSIIvqN7K0VSRBRatDjoyzyo34Mekd9BBlZVNpezD7c8Xiud+6955xr4YKF586ePTPrnJnZe0ai/xDjmSXM0hixRMYQMSqY3TFmRTQCKqWRWKFbxhAxKmlAQFTwRMAk5leK7bo4EY2ATCk7yzwYA75iNrkhINO0EZfRRDESkMZcEAXTwhEwiLmcecsmIIFZJmWnKHgAKmZOtLVZR9HN+zpNQLv0U8hMdxr8DZszEM+8HUaHHaTenAU3v4Dezxe7iJViyGNWaQJWyXM2M86u2gaE/6fMH9KeEzKiEGBNockypmK94T1SOJh6rgGrPD7E4C2kMu8zfzE3OdjfUeRTSF8DvWKFPuhgz6ZIZt5kdjF32WxufAHPBQBY+PXiuzcCfzt8FwBgOp4Rf/yNJsVup8AuVOqXAAC7237yJg3xRYBXGBAQa/giIIW5mXmZ+YL5TYjnS6TiREqEbXsqAAu3gPlRfF+TSsNrhXh+I7YPzHzxCQeeCcAbvSY+yKHmkHMKEie2O1L3CoX3NYwF4Hbgt2GjCF53SaURBQ52JF9O1yU7xKeZOcSwL2MB6HC1YaMnSaUP6xxsOWLDy1jrYM8S+3HDvowFmGIG8w/zcBD7S+Yz5kNma5A6NdLGNIP+jAXgbT0xaPAq8xNzuINtJgXS32x5znCoN4L5mdlg0J+rUwiLr5N5SH4PJXUQvyhsIzXHJ5DKLlG3VbMfEB8AXwHniWFuCTDBYqk/T37jDIH5jC/3iPmAuUWrv4Z5T2yPSU2bcrHNl7YWuiVgPam52xfypP5o+Y3k7SepIBYKS5jfmdXye6y0lRvCz9U4YB34E+T3SFLbKcpOMxMdfBC4ENS6pG6qlCeKX5mfAnKlzhitDGeBainf7eCTJTacv/Xj6jgpzwnRp6sCFlHPNWAh3akjwVaxpdvKXV8D+nMwWLvQEVt5kfjOIrW9VkkdfKlRpIJakc3nKKk1keynAAC5jD0ONJJK1maTOg52ClFvKamgdl2rb8WBeoP+XBcwndR2qH+FGgoc/xALpgjbtHK9fq20MTUWAgBcf+u5EHaUAmGSVi9JyvIpsENZudAxw748EYBttIVU1N1p6AMUik8TeZCN6s8mwIJuEJ9m5lwKfh6ArUXq4tQWauHq8PREhsFtI7WA4fuWeY4CJ7LzFLhifE9qzw9172qHL2divNGNpBK256Rurjvk+QJzA4X31nX0KcDp/8T9Db0EWPkMUgCk0Ag6SImbpdz0dtoPYIwYU7leaKXEiIz6YJdJ+XYK/+bAC2AMOENjTCt0AxaRdZv8L7CRHF4oRCAxs6ZPf+Q+Uv/H609TOjr8Bd1ki37pdiLIAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/projectIcon.325e8b05d9a0678c8c83918a9dae47b1.svg";
export { ForwardRef as ReactComponent };